import React from 'react';
import classNames from 'classnames';
import { checkLinkAndAppendLanguage } from 'utils/localization';
import * as styles from './styles.module.scss';

enum AnchorButtonVariant {
  Primary,
  Secondary
}

// different enough from Button I kept this a separate component; 6s
const AnchorButton: React.FC<{ href: string; className?: string; onClick?: () => void; variant?: AnchorButtonVariant }> = ({
  children,
  href,
  className,
  onClick,
  variant = AnchorButtonVariant.Primary
}) => (
  <a
    className={classNames(styles.anchor, className, {
      [styles.primary]: variant === AnchorButtonVariant.Primary,
      [styles.secondary]: variant === AnchorButtonVariant.Secondary
    })}
    href={checkLinkAndAppendLanguage(href)}
    {...(onClick && { onClick })}
  >
    {children}
  </a>
);

export { AnchorButton as default, AnchorButtonVariant };
